<mat-card-content id="printPageButton" class="sticky-header">
  <div class="flex flex-col gap-4 justify-start items-center">
    <button mat-raised-button color="primary" (click)="print()">Print</button>
  </div>
</mat-card-content>

<mat-dialog-content style="color: black;">
  <div id="serviceCenterPrintContent" style="width:100%; position:relative;" class="p-6">
  <div style="position:absolute; inset:0; background-image:url('assets/images/transparentSeal.png'); background-repeat:no-repeat; background-position:center; background-size:contain; opacity:0.25; pointer-events:none; z-index:0;"></div>
  <div style="position:relative; z-index:1;" class="flex flex-col gap-2">
    <img src="assets/images/OHA-Color-Small.png" alt="OHA Logo" class="block ml-auto">
    <div>
      <h3 style="border-bottom: 1px solid currentColor; padding-bottom: 4px;">Psilocybin Service Center License</h3>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Operational Name</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.entityName}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Service Center License ID</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.licenseId}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-8 flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Address</strong></span>
          <span>Physical Address</span>
          <div class="flex flex-row gap-2">
            <span>{{license.physicalStreet}} {{license.physicalCity}}, {{license.physicalState}} {{license.physicalZip}} {{license.physicalCounty}}</span>
          </div>
          <span *ngIf="!license.mailingIsPhysical">Mailing Address</span>
          <div class="flex flex-row gap-2" *ngIf="!license.mailingIsPhysical">
            <span>{{license.mailingStreet}} {{license.mailingCity}}, {{license.mailingState}} {{license.mailingZip}} {{license.mailingCounty}}</span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h3 style="border-bottom: 1px solid currentColor; padding-bottom: 4px;">Psilocybin Service Center License Information</h3>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Approved Date</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.approvedDate}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Expiration Date</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.expirationDate}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-8 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Applicants</strong></span>
          <div *ngFor="let applicant of applicants" class="flex flex-row gap-2">
            <span>{{applicant.legalFirstName}} {{applicant.legalLastName}}</span>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span><strong>Entity Applicants</strong></span>
          <div *ngFor="let entity of entityApplicants" class="flex flex-row gap-2">
            <span>{{entity.entityName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="p-t-8 flex flex-row gap-4 justify-between items-center">
      <div class="flex flex-col gap-2">
        <span><strong>Licensing Manager Signature</strong></span>
        <div class="flex flex-row gap-2">
          <img src="assets/images/manager-signature.png" alt="Licensing Manager Signature" style="max-height: 50px; margin-left: -25px;">
        </div>
      </div>
      <qrcode [qrdata]=" url + '/license-information/'+ 'ServiceCenter/' + license.id"></qrcode>
    </div>
  </div>
  </div>
</mat-dialog-content>
